import { INITIALIZED } from './constants.js';

var loadedClb = function loadedClb(i18n, cb) {
  return function () {
    if (i18n.isInitialized) {
      cb(i18n);
    } else {
      var onInitialized = function onInitialized() {
        setTimeout(function () {
          i18n.off(INITIALIZED, onInitialized);
        }, 0);
        cb(i18n);
      };

      i18n.on(INITIALIZED, onInitialized);
    }
  };
};
function loadLanguages(i18n, lng, cb) {
  // eslint-disable-next-line no-void
  void i18n.loadLanguages(lng, loadedClb(i18n, cb));
}
function loadNamespaces(i18n, ns, cb) {
  // eslint-disable-next-line no-void
  void i18n.loadNamespaces(ns, loadedClb(i18n, cb));
}
var isTransOkay = function isTransOkay(t) {
  return !!(t != null && t.name) && (t == null ? void 0 : t.name) !== 'notReadyT';
};
var noop = function noop() {};

export { isTransOkay, loadLanguages, loadNamespaces, loadedClb, noop };
